import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { cellNotFilter, hasAllPermissions, hasPermission, useCheckPermissions, useTableFilter, useTableServerSideFiltering } from '@/shared';

import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';
import { ICausalIncidencia } from '@/shared/interfaces/erp/tickets-soporte-clientes';
import { useFetchCausalIncidencia, useUpdateCausalIncidencia } from '@/shared/actions/erp/causal-incidentes';

const returnUrl = '/tickets-soporte-cliente/causal-incidente';

export interface CausalIncidentePageInterface { }

const CausalIncidentePage: React.FC<CausalIncidentePageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_categoria_producto)

  const navigate = useNavigate();
  /*  const updSate = useUpdateCategoryProduct({ //error
     enableRedirect: false,
   }); */
  const updSate = useUpdateCausalIncidencia({
    enableRedirect: false
  })
  ///* global state
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex } = pagination;
  const{columnFilters, setColumnFilters, filterObject}=useTableServerSideFiltering()

  ///* fetch data
  const {
    data: categoryProductPagingRes,
    isLoading,
    isRefetching,
  } = useFetchCausalIncidencia({
    page: pageIndex + 1,
    nombre: searchTerm,
    ...filterObject,
    filterByState:false
  });

  ///* mutations


  ///* handlers
  const onEdit = (original: ICausalIncidencia) => {
    navigate(`${returnUrl}/editar/${original.id_causal_incidencia}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<ICausalIncidencia>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Código',
        size: 120,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
      },
      {
        accessorKey: 'categoria_incidencia_nombre',
        header: 'Categoria Incidencia'
      },
      {
        accessorKey: 'subcategoria_incidencia_nombre',
        header: 'SubCategoria Incidencia'
      },
      {
        ...cellNotFilter,
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <SwitchComponente
              estadoSwitch={row.original.estado}
              titulo={row.original.estado ? 'Activo' : 'Inactivo'}
              setEstadoSwitch={state => {
                if (!hasPermission(PermissionsEnum.api_change_categoria_producto)) return;

                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar Estado',
                  subtitle:
                    '¿Está seguro que desea cambiar el estado de esta categoria ?',
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    updSate.mutate({
                      id: row.original.id_causal_incidencia!,
                      data: { estado: !!state } as any,
                    });
                  },
                });
              }}
            />
          );
        },
      }
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Causal Incidencia" urlRedirect={`${returnUrl}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_categoria_producto)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Causal Incidencia" cleanFilter={cleanFilter} />

      <GeneralTable<ICausalIncidencia>
        columns={columns}
        data={categoryProductPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={categoryProductPagingRes?.data?.count}
        // // actions
        actionsColumnSize={120}
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_categoria_producto,
        ])}
        ///
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableManualFiltering={true}
        enableSorting={false}
        // crud
        onEdit={onEdit}
        canDelete={false}
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_categoria_producto,
        ])}
      />
    </SingleTableBoxScene>
  );
};

export default CausalIncidentePage;